//@flow

import * as React from 'react';
import { useIsSettingsSectionEnabled } from './useIsSettingsSectionEnabled';
import { Route, Redirect } from 'react-router-dom';
import SettingsContainer from './SettingsContainer';

export const SettingsRoute = ({ path }: { path: string }): React.Node => {
    const isEnabled = useIsSettingsSectionEnabled();
    if (isEnabled) {
        return <Route path={path} component={SettingsContainer} />;
    }
    return <Redirect to={{ pathname: '/' }} />;
};
